var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.checkConditions)?_c('div',{staticClass:"col-ip",on:{"click":function($event){return _vm.$store.dispatch('setCompany', _vm.entreprise)}}},[_c('GraphIp',{attrs:{"ip":_vm.getIp}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }